import clsx from 'clsx';
import { Popover as AriaPopover, composeRenderProps } from 'react-aria-components';

export function Popover({ className, loading, ...props }) {
  return (
    <AriaPopover
      offset={0}
      {...props}
      className={clsx(
        className,
        'mt-1 bg-white rounded-md border border-solid border-300 shadow-md bg-clip-padding outline-0',
      )}
    >
      {composeRenderProps(props.children, (children, { isEntering, isExiting }) => (
        <div
          className={clsx(
            'duration-700',
            isEntering && 'ease-out animate-in fade-in',
            isExiting && 'ease-in animate-out fade-out',
          )}
        >
          {children}
        </div>
      ))}
    </AriaPopover>
  );
}
